class deviceDetector {
	constructor(document) {
		this.root = document;
		this.OS = this.getOS();
		this.getElements();
		this.chooseButton();
	}

	getOS = () => {
		let userAgent = window.navigator.userAgent,
			platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
			// macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
			macosRegex = /^Mac/,
			windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
			iosPlatforms = ['iPhone', 'iPad', 'iPod'],
			os = null;

		if (macosRegex.test(platform)) {
			os = 'Mac OS';
		} else if (iosPlatforms.indexOf(platform) !== -1) {
			os = 'iOS';
		} else if (windowsPlatforms.indexOf(platform) !== -1) {
			os = 'Windows';
		} else if (/Android/.test(userAgent)) {
			os = 'Android';
		} else if (/Linux/.test(platform)) {
			os = 'Linux';
		}
		return os;
	};

	getElements = () => {
		this.downloadButtons = this.root.querySelectorAll('.download-js');
	};

	chooseButton = () => {
		this.downloadButtons.forEach((buttons) => {
			if (this.OS === 'Mac OS' || this.OS === 'iOS') {
				this.android = buttons.querySelector('.android');
				this.android.style.display = 'none';
			}
			if (this.OS === 'Android') {
				this.apple = buttons.querySelector('.apple');
				this.apple.style.display = 'none';
			}
		});
	};
}

document.addEventListener('DOMContentLoaded', () => new deviceDetector(document));
